import { JSX } from "react";
import type { VerificationInputProps as VerifyInputProps } from "react-verification-input";
import VerifyInput from "react-verification-input";

import { cn } from "@/utils/cn.ts";

interface VerificationInputProps extends VerifyInputProps {
  error: boolean;
}

const VerificationInput = ({ error, containerProps, ...otherProps }: VerificationInputProps): JSX.Element => {
  return (
    <VerifyInput
      {...otherProps}
      placeholder={""}
      validChars={"0-9"}
      classNames={{
        container: cn(
          "h-20 w-[25.625rem] flex gap-[0.625rem] max-lg:gap-[0.313rem] max-lg:w-[20.313rem] max-lg:h-[4.375rem]",
          containerProps,
        ),
        character: cn(
          "bg-surface-bright rounded-full h-20 flex items-center justify-center w-[3.75rem] hover:bg-red-1 text-on-primary max-lg:w-[3.125rem] max-lg:h-[4.375rem] outline-transparent -outline-offset-1 outline-1 outline border-none transition-outline",
          {
            "outline-red-1": error,
          },
        ),
        characterSelected:
          "pin-input bg-surface-container-high focus:outline-none border-none outline-on-primary transition-all",
        characterFilled: "bg-surface-container-high",
      }}
    />
  );
};

export default VerificationInput;
